import { Card, Text, Row, Text2 } from './common'
import { Button, Stack } from '@mui/material'

const DissolutionSpace = ({ onDissolve }: { onDissolve(): void }) => {
  return (
    <Card>
      <Row sx={{ py: 0, alignItems: 'flex-start' }}>
        <Text sx={{ width: 300 }}>
          空间解散
          <Text2 sx={{ color: 'rgba(0,0,0,0.5)' }}>永久删除空间及其所有数据，请谨慎操作</Text2>
        </Text>
        <Stack direction='row' sx={{ flex: 1 }} justifyContent='flex-end'>
          <Button size='small' color='error' onClick={onDissolve}>
            解散
          </Button>
        </Stack>
      </Row>
    </Card>
  )
}

export default DissolutionSpace
